// src/pages/admin/AdminDizimo.js

import React, { useState, useEffect, useCallback } from 'react';
import { getDizimistas } from '../../services/api';
import Toast from '../../components/common/Toast';
import { formatDate } from '../../utils/helpers';

const COMUNIDADES = [
  'Matriz','Menino Jesus',
  'Santa Teresinha','Nossa Senhora de Fátima – Canaã',
  'Nossa Senhora das Graças – Paupina'
];

const AdminDizimo = () => {
  const [dizimistas, setDizimistas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);
  const [filtro, setFiltro] = useState('');
  const [filtroComunidade, setFiltroComunidade] = useState('');

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getDizimistas();
      // Garante que sempre é array independente do que o GAS retornar
      const lista = Array.isArray(data?.data) ? data.data : [];
      setDizimistas(lista);
    } catch {
      setToast({ msg: 'Erro ao carregar dizimistas.', type: 'error' });
      setDizimistas([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const lista = Array.isArray(dizimistas) ? dizimistas : [];

  const filtrados = lista.filter(d => {
    const busca = filtro.toLowerCase();
    const ok = !filtro || d.nome?.toLowerCase().includes(busca) || d.telefone?.includes(filtro);
    const okComunidade = !filtroComunidade || d.comunidade === filtroComunidade;
    return ok && okComunidade;
  });

  return (
    <div style={{ padding: 'var(--space-2xl)' }}>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--space-xl)', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h2 style={{ marginBottom: '0.25rem' }}>Dizimistas</h2>
          <p style={{ color: 'var(--gray-400)', fontSize: '0.9rem' }}>
            {lista.length} dizimista{lista.length !== 1 ? 's' : ''} cadastrado{lista.length !== 1 ? 's' : ''}
          </p>
        </div>
        <button className="btn btn-navy btn-sm" onClick={carregar}>↻ Atualizar</button>
      </div>

      {/* Filtros */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-md)', marginBottom: 'var(--space-xl)' }}>
        <input type="text" className="form-input"
          placeholder="Buscar por nome ou telefone..."
          value={filtro} onChange={e => setFiltro(e.target.value)} />
        <select className="form-select" value={filtroComunidade} onChange={e => setFiltroComunidade(e.target.value)}>
          <option value="">Todas as comunidades</option>
          {COMUNIDADES.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      {/* Estatísticas por comunidade */}
      {!loading && lista.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '0.75rem', marginBottom: 'var(--space-xl)' }}>
          {COMUNIDADES.map(c => {
            const count = lista.filter(d => d.comunidade === c).length;
            if (!count) return null;
            return (
              <div key={c} style={{ background: 'var(--white)', borderRadius: 'var(--radius-md)', padding: '0.875rem 1rem', boxShadow: 'var(--shadow-sm)', borderLeft: '3px solid var(--gold)' }}>
                <div style={{ fontSize: '1.4rem', fontWeight: 700, color: 'var(--navy)', fontFamily: 'var(--font-display)' }}>{count}</div>
                <div style={{ fontSize: '0.78rem', color: 'var(--gray-600)', marginTop: '0.2rem' }}>{c}</div>
              </div>
            );
          })}
        </div>
      )}

      {/* Tabela */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '4rem', color: 'var(--gray-400)' }}>Carregando...</div>
      ) : filtrados.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '4rem', color: 'var(--gray-400)' }}>
          {lista.length === 0 ? 'Nenhum dizimista cadastrado ainda.' : 'Nenhum resultado para os filtros aplicados.'}
        </div>
      ) : (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Telefone</th>
                <th>Nascimento</th>
                <th>Sexo</th>
                <th>Comunidade</th>
                <th>Endereço</th>
                <th>Cadastro</th>
              </tr>
            </thead>
            <tbody>
              {filtrados.map((d, i) => (
                <tr key={d.id || i}>
                  <td><strong>{d.nome}</strong></td>
                  <td>{d.telefone}</td>
                  <td>{d.dataNascimento ? formatDate(d.dataNascimento) : '—'}</td>
                  <td>{d.sexo || '—'}</td>
                  <td>
                    <span style={{ fontSize: '0.82rem', background: 'var(--gold-pale)', color: 'var(--navy)', padding: '0.2rem 0.6rem', borderRadius: '99px', fontWeight: 600 }}>
                      {d.comunidade || '—'}
                    </span>
                  </td>
                  <td style={{ fontSize: '0.85rem', color: 'var(--gray-600)' }}>
                    {[d.endereco, d.bairro, d.cidade].filter(Boolean).join(', ') || '—'}
                  </td>
                  <td style={{ fontSize: '0.82rem', color: 'var(--gray-400)' }}>
                    {d.dataCadastro ? formatDate(d.dataCadastro) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminDizimo;